import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RetailerLocation } from 'src/models/RetailerLocation';
import { ApiService } from '../api.service';
import { GoogleMap, MapGeocoder } from '@angular/google-maps'

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss']
})
export class LocationComponent implements OnChanges {
  private sub: any;
  mapOptions: google.maps.MapOptions;
  @Input() 
  location : RetailerLocation;
  @Output() locationDeleted = new EventEmitter<RetailerLocation>();
  @ViewChild("map")
  map : GoogleMap;
  mapVisible: boolean = false;
  
  mapMarkerLocation: google.maps.LatLng;
  circleOptions: google.maps.CircleOptions = {
    fillColor: "#f5ad42",
    strokeWeight: 1,
    fillOpacity: .2,
    strokeColor: "#f59342"
  };
  constructor(private route: ActivatedRoute, private api: ApiService, private geo: MapGeocoder) {

  }
  mapDebounce: any = null;
  ngOnChanges(changes: SimpleChanges): void {
    //this.onChange();
    this.checkUpdateMap()
  }
  deleteLocation() {
    this.location.isDeleted = true;
    this.locationDeleted.emit(this.location);
  }
  onChange(): void {
    console.log("changes detected");
    this.location.hasChanges = true;
    if (this.mapDebounce) {
      clearTimeout(this.mapDebounce);
    }
    this.checkUpdateMap();
    
  }

  checkUpdateMap() {
    this.mapVisible = false;
    this.mapDebounce = setTimeout(() => {
      if (location && this.location.address1 && this.location.city && this.location.state && this.location.postalCode) {
        this.mapVisible = true;
        setTimeout(() => {
          this.updateMap();
        }, 10);
        this.updateMap();
      }
    }, 1500);
  }
  ngOnInit() {
    if (this.location && !this.location.geofenceRadiusKM) {
      this.location.geofenceRadiusKM = .001;
    }
    // this.sub = this.route.params.subscribe(params => {
    //    this.loadLocation(params['retailerId'], params["locationId"]);
    // });
  }

// private async loadLocation(retailerId: string, locationId: string) {
//   this.mapOptions = null;
//   const loc = await this.api.getRetailerLocation(retailerId, locationId);
//   this.location = loc;
//   await this.updateMap();
// }

  // makeDisplayAddress() : string {
  //   if (!this.location) {
  //     return "";
  //   }
  //   return `${this.location.address1}${this.location.city}${this.location.state}${this.location.postalCode}`;
  // }

private async updateMap() {
  if (this.location) {
    let addr = `${this.location.address1} ${this.location.address2} ${this.location.address3} ${this.location.city}, ${this.location.state} ${this.location.postalCode}`
    console.log("doing geo");

    const loc = await this.geo.geocode({ address: addr }).toPromise();
    console.log("location is " + JSON.stringify(loc));
    if (loc && loc.results && loc.results.length > 0 && loc.results[0].geometry && loc.results[0].geometry.location) {
      const latlong = loc.results[0].geometry.location;
      this.mapOptions = {
        center: latlong,
        disableDefaultUI: true,
        zoomControl: true,
        draggable: false
      }
      this.mapMarkerLocation = latlong;
      setTimeout(() => {
        this.updateRadius();
      }, 100);
    }
  }
}

updateRadius() {
  this.location.hasChanges = true;
  if (this.mapOptions) {
    const c = new google.maps.Circle({ center: this.mapOptions.center, radius: (this.location.geofenceRadiusKM||.1) * 1000});
    this.map.fitBounds(c.getBounds(), 100);
  }
}

  ngOnDestroy() {
   // this.sub.unsubscribe();
  }
}
